import { Card } from "components";
import FormError from "pages/accounts-onboarding/components/form-error/FormError";
import React from "react";

import LoginFooter from "./LoginFooter";
import LoginFormBody from "./LoginFormBody";
import LoginHeader from "./LoginHeader";

import styles from "../Login.module.css";

const LoginForm = () => {
	return (
		<Card className={styles.card}>
			<div className={styles.form}>
				<LoginHeader />
				<FormError />
				<LoginFormBody />
				<LoginFooter />
			</div>
		</Card>
	);
};

export default LoginForm;
